<template>
	<Container>
		<TopBar/>
		<div class="item">
			<iframe v-if='lesson.Type == "002"' :src="lesson.Href +'?flag='+lesson.Flag" class='video' v-else></iframe>
			<Video v-else class='video' @onPlayEnded='onPlayEnded' :seekable='lesson.Flag >= 2' :src='lesson.Href' :pic='lesson.Pic'/>
			<span class="tag">{{lesson.Flag | lessonStatus}}</span>
			<div class="desc">
				<div class="name"><div>{{lesson.Title}}</div></div>

				<p class="center">课节:第{{lesson.No}}课节&nbsp;&nbsp;时长:{{lesson.LessonDuration | format}}</p>
				<div class="right"><a :href='lesson.Href.replace("Lesson","Lesson/symlink")' class="download"><Icon type="md-download" />下载视频</a>&nbsp;&nbsp;&nbsp;&nbsp;<div>观看量: {{lesson.VisitTimes}} &nbsp;&nbsp;&nbsp;&nbsp;时间:{{lesson.PublishDate}}</div></div>
			</div>
			<div class="content">
				<div class="buttons">
					<div v-if='lesson.Flag >= 2||exameEnable' @click='goExamine' class="button button-primary">{{lesson.Flag > 2 ? '重新考核':'开始考核'}}</div>
					<div @click='trigerRecord' v-if='lesson.Flag > 2' class="button button-primary">考核记录<Icon size='20' :type="showRecord ? 'md-arrow-dropup':'md-arrow-dropdown'" /></div>
				</div>
				<div class="records" v-if='showRecord'>
					<div class="record" v-for='record in records' v-if='record'>
						<div class="e-date">考核时间：{{record.BeginTime.replace('T',' ').substring(0,19)}} - {{record.EndTime.replace('T',' ').substring(0,19)}}</div>
						<div class="right">
							<div>{{record.Score}}分</div>
							<Tag class='r-tag' v-if='record.Flag == 11' color="success">通过</Tag>
							<Tag class='r-tag' v-else color="default">未通过</Tag>
						</div>
						<a :href='"#/train/result?code="+record.RecordCode + "&ec=" + record.ExamCode' class="button button-primary">查看详情</a>
					</div>
				</div>
				<div class="html">
					<div v-html='lesson.Content'></div>
				</div>
				
			</div>
		</div>
	</Container>
</template>

<script>
	import TopBar from '@/components/common/TopBar'
	import Video from '@/components/common/Video'
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	import util from '@/config/util'
	export default {
		data() {
			return {
				lesson:{},
				guid:'',
				exameEnable:false,
				records:[],
				showRecord:false,
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		filters:{
			format(value){
				if(value < 0)return '00:00'
				let hour = parseInt(value / 3600)
				let minute = parseInt((value - hour * 3600) / 60)
				let second = parseInt(value - hour * 3600 - minute * 60)
				if(hour)return `${hour > 9?hour:'0'+hour}:${minute > 9 ? minute:'0'+minute}:${second > 9 ? second : '0'+second}`
				return `${minute > 9 ? minute:'0'+minute}:${second > 9 ? second :'0'+second}`
			},
			lessonStatus(value){
				let status = {
					0:'未观看',
					1:'学习中', 
					2:'已看完',
					10:'考核中', 
					11:'考核通过', 
					12:'考核未通过', 
					30: '获取了达人卡'
				}
				return status[value]
			}
		},
		watch:{

		},
		mixins:[],
		components: {
			TopBar,
			Video,
		},
		computed: {
			...mapState({

			}),
		},
		methods: {
			...mapActions([
				'getELearnLessonAction',
				'reportLessonProgressAction',
				'getExamRecordAction',
			]),
			async initData(){
				let lc = this.$route?.query?.lessonCode
				this.guid = util.guid()
				// let {lesson} = this.getParams()
				// this.lesson = lesson
				this.lesson = await this.reportLessonProgressAction({
					flag:1,
					lc,
					prgs:1,
					rcode:this.guid,
				})
				window.addEventListener('message', e => {
					console.log(e.data)
				    let action = e.data.action;
				    if (action == 'onPlayEnded') {
				    	this.onPlayEnded()
				    }
				})
				
			},
			async trigerRecord(){
				let lc = this.$route?.query?.lessonCode
				this.showRecord = !this.showRecord
				if (!this.records.length) {
					this.records = await this.getExamRecordAction(lc)
				}
			},
			onPlayEnded(e){
				this.exameEnable = true
				let lc = this.$route?.query?.lessonCode
				this.reportLessonProgressAction({
					flag:2,
					lc,
					prgs:this.lesson.LessonDuration,
					rcode:this.guid,
				})
				this.$Modal.confirm({
					title:'确认',
					content:'视频已看完，是否前往考核',
					okText:'前往考核',
					onOk:()=>{
						this.goExamine()
					}
				})
			},
			goExamine(){
				this.routerPush({
					path:'/train/examine',
					query:{
						lessonCode:this.$route?.query?.lessonCode,
						code:this.lesson.ExamCode
					}
				})
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/common';
	@import '@/style/mixin';
	.item {
		width:80vw;
		max-width: 1044px;
		margin: 20px auto;
		margin-bottom: 30px;
		overflow: hidden;
		position: relative;
		.video {
			max-width: 1044px;
			max-height: 587px;
			width:80vw;
			height:45vw;
		}
		.tag {
			position: absolute;
			right: 20px;
			top: 20px;
			background-color: $theme-color;
			color:white;
			padding: 3px 20px;
			border-radius: 20px;
		}
		.desc {
			display: flex;
			margin: 20px 0;
			.name {
				@include fontSize($font-size-20);
				flex:1;
			}
			.center {
				flex:1;
				color:#666;
				@include fontSize($font-size-16);
			}
			.right {
				color:#666;
				display: flex;
				@include fontSize($font-size-16);
				.download {
					cursor: pointer;
					color:#666;
					&:hover {
						color:$theme-color;
					}
				}
			}
		}
		.content {
			.html {
			}
			.buttons {
				display:flex;
				justify-content: center;
				margin-bottom: 20px;
				.button {
					width: 200px;
					height:35px;
					margin:0 40px;

				}
			}
			.records {
				.record {
					display: flex;
					border-bottom: 1px solid #ddd;
					padding:10px 20px;
					.e-date {
						flex:1;
						align-self: center;
					}
					.right {
						text-align: center;
						.r-tag {
							margin-top: 5px;
							width: 60px;
							height:26px;
							text-align: center;
							padding: 2px 0;
							border-radius: 20px;
						}
					}
					.button {
						height:20px;
						margin-left: 10px;
						align-self: center;
						background-color: #fff;
						color: $theme-color;
						&:hover {
							color:$dark-theme-color;
							box-shadow: none;
						}
						
					}
				}
			}
		}
	}
	@media (max-width: 768px){
		.item {
			width: 95vw;
			.video {
				width:95vw;
				height:53.4375vw;
			}
		}
	}
</style>